import { ApiClientBase, FileModel } from "./api";
import { IApiConfig } from "./ApiConfig";

/** Resolves App media through the ordinary or embed-scoped API transport. */
export class AppMediaClient extends ApiClientBase {
  constructor(config: IApiConfig, private readonly baseUrl: string,
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> } = { fetch: globalThis.fetch.bind(globalThis) }) {
    super(config);
  }

  async get(definitionId: string, resourceId: string, componentId: string, signal?: AbortSignal): Promise<FileModel> {
    const url = `${this.baseUrl}/Bundle/${encodeURIComponent(definitionId)}/media/${encodeURIComponent(resourceId)}?componentId=${encodeURIComponent(componentId)}`;
    const response = await this.http.fetch(url, await this.transformOptions({ method: "GET", signal }));
    if (!response.ok) throw new Error(`App image is unavailable (${response.status}).`);
    return response.json();
  }
}
